import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslationPipe } from '../shared/pipes';

@Component({
  selector: 'app-not-found',
  standalone: true,
  templateUrl: './not-found.component.html',
  imports:[TranslationPipe]
})
export class NotFoundComponent implements OnInit {
  constructor(private readonly titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('IREDO - Stránka nenalezena');
  }
}
